import React from 'react';
import MemoryGame from './MemoryGame';
import './MemoryGameModal.css';

export default class MemoryGameModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      gameCompleted: false,
      finalMoves: 0
    };
  }

  hide = () => {
    this.setState({isVisible: false});
    const {onClose} = this.props;
    if (typeof onClose === 'function') {
      onClose();
    }
  }

  handleGameCompleted = (moves) => {
    this.setState({gameCompleted: true, finalMoves: moves});
    const {onGameCompleted} = this.props;
    if (typeof onGameCompleted === 'function') {
      onGameCompleted();
    }
  }

  resetGame = () => {
    this.setState({gameCompleted: false, finalMoves: 0});
    if (this.memoryGameRef) {
      this.memoryGameRef.resetGame();
    }
  }

  renderGameContent = () => {
    const {
      memoryGame,
      user,
    } = this.props;
    
    const {
      images,
      placeholderImage,
      selectedImagesNumber,
      addedDefaultCardsImage,
      memoryGameTitle,
      memoryGameWinSuccessMessage,
      memoryGamePopupTitle,
      memoryGamePopupSubtitle,
      memoryGameWinningTitle,
      memoryGameWinningSubtitle,
      memoryGameScoreText,
      memoryGameMovesText,
      memoryGamePopupBottomText,  
    } = memoryGame || {};
    const {gameCompleted, finalMoves} = this.state;

    if (!images || images.length === 0 || !selectedImagesNumber) {
      return (
        <div className="empty-container">
          <h2 className="title-style">{memoryGamePopupTitle || memoryGameTitle || 'משחק הזיכרון'}</h2>
          <p className="text-style">{memoryGamePopupSubtitle || 'אין תמונות זמינות למשחק זיכרון'}</p>
          <button className="ok-btn" onClick={this.hide}>
            סגור
          </button>
        </div>
      );
    }

    if (gameCompleted) {
      const targetMoves = selectedImagesNumber + 4;
      const isExcellent = finalMoves < targetMoves;
      
      return (
        <div className="completed-container">
          <div className="winning-content-wrapper">
            <h2 className="title-style">
              {(memoryGameWinningTitle || (isExcellent ? '🏆 מעולה' : '🎉 מזל טוב')).replace('{first_name}', user?.first_name || 'שחקן')} {isExcellent ? '🏆' : '🎉'}
            </h2>
            <p className="text-style">
              {memoryGameWinningSubtitle || memoryGameWinSuccessMessage || 'השלמת את משחק הזיכרון!'}
            </p>
          </div>
          <div className="button-container">
            <button className="ok-btn" onClick={this.hide}>
              לבחירת המתנה
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="game-container">
        <h2 className="title-style">{memoryGamePopupTitle || memoryGameTitle || 'משחק הזיכרון'}</h2>
        {memoryGamePopupSubtitle && <p className="subtitle-style">{memoryGamePopupSubtitle}</p>}
        
        <MemoryGame
          ref={ref => this.memoryGameRef = ref}
          images={images}
          placeholderImage={placeholderImage}
          selectedImagesNumber={selectedImagesNumber}
          addedDefaultCardsImage={addedDefaultCardsImage}
          memoryGameScoreText={memoryGameScoreText}
          memoryGameMovesText={memoryGameMovesText}
          memoryGamePopupBottomText={memoryGamePopupBottomText}
          onGameCompleted={this.handleGameCompleted}
        />
        
        <div className="button-container">
          <button className="text-button" onClick={this.hide}>
            דלג
          </button>
          <button className="text-button" onClick={this.resetGame}>
            התחלה מחדש
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {isVisible} = this.state;

    if (!isVisible) {
      return null;
    }

    try {
      const {gameCompleted} = this.state;
      return (
        <div className="modal-overlay">
          <div className={`modal-content ${gameCompleted ? 'winning-modal' : ''}`}>
            {this.renderGameContent()}
          </div>
        </div>
      );
    } catch (error) {
      return null;
    }
  }
} 